<template>
  <v-container :class="$vuetify.breakpoint.mdAndUp ? '' : 'mx-0 px-0'">
    <base-material-card
      icon="mdi-file-document"
      color="primary"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          {{ $t("inspectionProfile.inspectionMultimedia") }}
        </div>
      </template>

      <v-dialog v-model="dialog" fullscreen persistent>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            top
            right
            absolute
            color="success"
            dark
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-toolbar color="primary">
            <v-toolbar-title class=" white--text">
              {{ $t("inspectionProfile.addMultimedia") }}</v-toolbar-title
            >
            <v-spacer> </v-spacer
            ><v-icon @click="cancelUpload" x-large dark> mdi-close</v-icon>
          </v-toolbar>
          <v-container>
            <v-card-text class="my-4">
              <upload-media
                :uid="inspectionProfile.id"
                @done="addDownloadUrl"
              />
              <v-textarea
                v-model="details"
                row-height="4"
                :label="$t('inspectionProfile.multimediaDetails')"
                filled
                persistent-hint
                :hint="$t('inspectionProfile.multimediaHint')"
              ></v-textarea>
            </v-card-text>

            <v-card-actions class="mb-4">
              <v-spacer></v-spacer>
              <v-btn
                width="250"
                x-large
                rounded
                color="success darken-2"
                @click="updateMediaList"
              >
                {{ $t("inspectionProfile.buttons.upload") }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-row justify="space-around" v-if="media.length > 0">
        <media-element
          v-for="(item, index) in media"
          :key="index"
          :item="item"
          :index="index"
          @delete="deleteElement"
          @remove="media.splice(index, 1)"
        />
      </v-row>
      <div class="my-12 d-flex flex-column justify-center align-center" v-else>
        <h3 class="text-center">
          {{ $t("inspectionProfile.multimediaMessage") }} 😥
        </h3>

        <v-btn
          @click="dialog = true"
          class="my-4"
          width="200"
          color="success"
          x-large
        >
          {{ $t("inspectionProfile.buttons.addFile") }}
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { db, storage } from "@/plugins/db";

export default {
  data() {
    return {
      dialog: false,
      temporaryDownloadUrl: null,
      details: ""
    };
  },
  components: {
    "upload-media": () => import("./UploadMedia"),
    "media-element": () => import("./MediaElement")
  },
  computed: {
    ...mapState("inspections", ["inspectionProfile"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["isMetric", "isMetax"]),
    media() {
      return this.inspectionProfile?.media || [];
    }
  },
  methods: {
    cancelUpload() {
      this.dialog = false;
      this.temporaryDownloadUrl = null;
      this.details = "";
    },
    addDownloadUrl(item) {
      this.temporaryDownloadUrl = item;
    },
    updateMediaList: async function() {
      if (this.temporaryDownloadUrl) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        if (!this.inspectionProfile.media) {
          this.inspectionProfile.media = [];
        }
        this.inspectionProfile.equipmentProfile = db
          .collection("equipments")
          .doc(this.inspectionProfile.equipmentProfile.id);
        this.inspectionProfile.media.push({
          url: this.temporaryDownloadUrl,
          details: this.details
        });
        let payload = {
          doc: this.inspectionProfile.id,
          db: "inspections",
          data: this.inspectionProfile
        };

        try {
          await this.$store.dispatch("updateDocument", payload);
          this.$dialog.notify.success("Document updated successfully", {
            position: "top-right",
            timeout: 5000,
            icon: "mdi-paperclip"
          });
          this.cancelUpload();
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000,
            icon: "mdi-paperclip"
          });
        } finally {
          loading.close();
        }
      } else {
        this.$dialog.notify.error("No files have been uploaded yet", {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-paperclip"
        });
      }
    },
    deleteElement: async function(item, type, name, index) {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      const newMedia = this.inspectionProfile.media.filter(
        elem => elem !== item
      );
      this.$delete(this.media, index);
      this.inspectionProfile.equipmentProfile = db
        .collection("equipments")
        .doc(this.inspectionProfile.equipmentProfile.id);
      let payload = {
        doc: this.inspectionProfile.id,
        db: "inspections",
        data: { ...this.inspectionProfile, media: newMedia }
      };
      try {
        await this.$store.dispatch("updateDocument", payload);

        await storage
          .ref(`inspections/${this.inspectionProfile.id}/${type}/${name}`)
          .delete()
          .then(() => {
            console.log(`${name} deleted`);
          });

        this.$dialog.notify.success("Media element deleted", {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-paperclip"
        });
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000,
          icon: "mdi-paperclip"
        });
      } finally {
        loading.close();
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.v-dialog--fullscreen > .v-card
  min-height: 150vh
</style>
